require('./cardPaymentPurchaseDeferralError.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardError = require('components/commons/wizardError/wizardError');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @constants
const { DEFERRED_PAYMENT_INSUFFICIENT_BALANCE_ERROR_CODE, DEFERRED_PAYMENT_SUM } = require('constants/index');

const CardPaymentPurchaseDeferralError = props => {
    const { 
        descriptionError,
        error,
        immCard,
        immProfile,
        modifyLimit,
        onMainButtonClick,
        processDetail,
        productName,
    } = props;
    const title = formatText('cardPaymentPurchaseDeferralError-title');
    const cardAlias = immCard.getIn(['alias', 'current']);
    let modifyLimitButton;
    const goBackButton = {
        label: (
            <FormattedText
                value={'cardPaymentPurchaseDeferralError-goBackButton'}
                format="uppercase"
                injectedStrings={[cardAlias]}
            />
        ),
        url: `/myprofile/cards/${immCard.get('cardId')}/movements`
    };

   if (!immProfile.get('isNerudaUser') && (error === DEFERRED_PAYMENT_INSUFFICIENT_BALANCE_ERROR_CODE || error === DEFERRED_PAYMENT_SUM)) {
        modifyLimitButton = (
            <div className="card-payment-purchase-deferral-error__modify-limit-button">
                <OKButton
                    modifier="secondary"
                    size="regular"
                    onClick={modifyLimit}
                >
                    <FormattedText value="cardDetails-limitLink" />
                </OKButton>
            </div>
        )
    }

    return (
        <article className="card-payment-purchase-deferral-error row no-gutter">
            <div className="col-xs-offset-2 col-xs-8">
                <WizardError
                    descriptionError={descriptionError}
                    errorMessage={title}
                    mainButton={goBackButton}
                    onMainButtonClick={onMainButtonClick}
                    processDetail={processDetail}
                    productName={productName}
                >
                    <section className="row no-gutter">
                        <div className="col-xs-6 col-md-5">
                            <CommercialAds
                                path="cards"
                                type="cards"
                                immCard={immCard}
                                size="medium"
                            />
                        </div>
                        <div className="col-xs-6 col-md-7">
                            <FormattedText
                                value={`cardAPIErrors-${error}`}
                                defaultMessageCode="cardPaymentPurchaseDeferralError-errorMessage"
                            />
                        </div>
                        {modifyLimitButton}
                    </section>
                </WizardError>
            </div>
        </article>
    );
};

CardPaymentPurchaseDeferralError.defaultProps = {
    onMainButtonClick: null,
}

CardPaymentPurchaseDeferralError.propTypes = {
    immCard: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    descriptionError: PropTypes.string,
    error: PropTypes.string.isRequired,
    modifyLimit: PropTypes.func.isRequired,
    onMainButtonClick: PropTypes.func,
    processDetail: PropTypes.string,
    productName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
};

module.exports = CardPaymentPurchaseDeferralError;
